import type {ChatMessage, PendingInputRequest} from "~/pages/chat-agent/types/chatTypes";

/** Tool names that pause the run to ask the user a free-form question (ADK's `request_input` tool). */
export const HUMAN_INPUT_TOOL_NAMES = new Set(['adk_request_input']);
export const DEFAULT_REQUEST_INPUT_QUESTION = 'The agent needs more information to continue.';

/**
 * The `function_response` that resumes a paused call with the user's answer. ADK's
 * FunctionResponse.response is always a dict, so the plain-text answer is wrapped under "result".
 */
export function buildRequestInputResponse(pending: PendingInputRequest, answer: string) {
    return {id: pending.callId, name: pending.toolName, response: {result: answer}};
}

/**
 * Reverse of buildRequestInputResponse: the answer text from a resumed call's response. A structured
 * answer (e.g. sent by another client) falls back to its JSON, so every answer keeps a bubble.
 */
export function extractRequestInputAnswer(response: unknown): string {
    if (typeof response === 'string') return response;
    const result = (response as {result?: unknown} | null | undefined)?.result;
    return typeof result === 'string' ? result : JSON.stringify(response ?? null);
}

/**
 * The question the run is paused on: the latest `request_input` since the user's last message. Every
 * answer becomes a user bubble, so a question followed by one is answered. The question need not be
 * last, since the paused event can carry other parts.
 */
export function findPendingInput(messages: ChatMessage[]): PendingInputRequest | null {
    for (let i = messages.length - 1; i >= 0 && messages[i].type !== 'user'; i--) {
        const {event_type, requestInput} = messages[i];
        if (event_type === 'request_input' && requestInput) return requestInput;
    }
    return null;
}
